import React from 'react';
import { startCase, isNil } from 'lodash';
import { Tag, TagProps } from 'antd';

type StatusBadgeObjProps = {
  val: string;
  startCase?: boolean;
  color?: TagProps['color'];
};

type StatusBadgeProps = string | number | boolean | StatusBadgeObjProps;

const statusColor: { [key: string]: string } = {
  ACTIVE: 'success',
  INACTIVE: 'error',
  DRAFT: 'warning',

  PENDING: 'warning',
  RESOLVED: 'success',
  PROCESSING: 'processing',
  CONVERTED: 'success',
  CONVERSION_FAILED: 'error',
  DOWNLOAD_FAILED: 'error',

  false: 'error',
  true: 'success',

  RUNNING: 'success',
  PAUSED: 'warning',
  STOPPED: 'error',
};

/**
 * NOTE: Not exactly a component as it also works as a function directly
 */
function StatusBadge(props?: StatusBadgeProps) {
  let val: string;
  let color: TagProps['color'] | undefined;
  let convertToStartCase: boolean | undefined = true;
  let rest: TagProps = {};

  if (isNil(props) || ['string', 'number', 'boolean'].includes(typeof props)) {
    val = String(props ?? '-');
  }
  else {
    ({ val, startCase: convertToStartCase = true, color, ...rest } = props as StatusBadgeObjProps);
  }

  if (val === '-') return <>{val}</>;
  return (
    <Tag color={color || statusColor[String(val)] || 'purple'} style={{ margin: 0 }} {...rest}>
      {convertToStartCase ? startCase(String(val)) : val}
    </Tag>
  );
}

export default StatusBadge;
